var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "item-attachments" },
    _vm._l(_vm.attachments, function (attachment, index) {
      return _c("ul", { key: index }, [
        _c("li", [
          _c(
            "a",
            {
              attrs: { href: "javascript:;" },
              on: {
                click: function ($event) {
                  return _vm.downloadFile(attachment)
                },
              },
            },
            [
              _c("i", { class: _vm.mimeToIcon(attachment.mime) }),
              _vm._v(" " + _vm._s(attachment.name) + "\n            "),
            ]
          ),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }